<template>
	<div class="container-node-top container-node-top--right">
		<div
			v-for="tagItem in tagsData"
			:class='"Tag Tag--padding Tag--no-margin-right ext-margin-base-left " + tagItem.classes'
			:title="tagItem.title"
			v-bind:data-vue-method="tagItem.data['vue-method']"
			v-bind:data-target="tagItem.data.target"
			v-bind:data-toggle="tagItem.data.toggle"
			v-on:click="handleClickEvent"
		>
			<span :class="tagItem.icon"></span>
			<span
				v-if="tagItem.showPlusIcon"
				class="glyphicon glyphicon-plus"
				style="left: 0.25em; top: 0; font-size: 0.65em"
			></span>
		</div>
	</div>
</template>

<script>
import DrawflowHelpers from "./drawflow_helpers";

export default {
	props: {
		tagsToShow: Object,
		parentInstance: Object,
		modalId: {
			type: String,
			default: "#replace-me",
		},
	},
	components: {},
	computed: {
		tagProperties() {
			return {
				delete: {
					classes: "Tag--red",
					icon: "senaryon-icon senaryon-icon-trash",
					title: window.I18n.t("helpers.rails_verbs.destroy"),
					data: {
						"vue-method": "removeNode",
					},
				},
				duplicate: {
					classes: "Tag--gray",
					icon: "glyphicon glyphicon-duplicate",
					title: window.I18n.t("helpers.rails_verbs.duplicate"),
					data: {
						"vue-method": "duplicateNode",
					},
				},
				edit: {
					classes: "Tag--gray",
					icon: "senaryon-icon senaryon-icon-edit",
					title: window.I18n.t("helpers.rails_verbs.edit"),
					data: {
						"vue-method": "editNode",
					},
				},
				addGroup: {
					classes: "Tag--button-background j-modal-button",
					icon: "senaryon-icon senaryon-icon-roles",
					title: window.I18n.t("helpers.submit.new", {
						model: window.I18n.t("activerecord.models.group.one"),
					}),
					showPlusIcon: true,
					data: {
						"vue-method": "createModal",
						target: this.modalId,
						toggle: "modal",
					},
				},
				addArticle: {
					classes: "Tag--button-background j-modal-button",
					icon: "senaryon-icon senaryon-icon-negotiation",
					title: window.I18n.t("helpers.submit.new", {
						model: window.I18n.t("activerecord.models.article.one"),
					}),
					showPlusIcon: true,
					data: {
						"vue-method": "createModal",
						target: this.modalId,
						toggle: "modal",
					},
				},
				addMeasureOption: {
					classes: "Tag--button-background j-modal-button",
					icon: "senaryon-icon senaryon-icon-edit-curves",
					title: window.I18n.t("helpers.submit.new", {
						model: window.I18n.t("activerecord.models.measure_option.one"),
					}),
					showPlusIcon: true,
					data: {
						"vue-method": "createModal",
						target: this.modalId,
						toggle: "modal",
					},
				},
			};
		},
		tagsData() {
			return this.tagsToShow.map((tagName) => this.tagProperties[tagName]);
		},
	},
	methods: {
		handleClickEvent(event) {
			const $closestTag = $(event.target).closest(".Tag");
			pp.log(
				"into handleClickEvent",
				$closestTag,
				$closestTag.attr("data-vue-method"),
			);
			switch ($closestTag.attr("data-vue-method")) {
				case "createModal":
					// pp.log("modalId", this.modalId);
					if (this.modalId == "#replace-me") {
						this.drawflowHelpers.createModal();
					}
					break;

				case "duplicateNode":
					this.drawflowHelpers.duplicateNode();
					break;

				case "editNode":
					this.drawflowHelpers.editNode();
					break;

				case "removeNode":
					if (
						!$closestTag.hasClass("Tag--red") &&
						!$(event.target).hasClass("senaryon-icon-trash")
					) {
						pp.log("- not a direct click");
						return;
					}
					this.drawflowHelpers.removeNode();
					break;
			}
		},
	},
	mounted() {
		// pp.log("mounted drawflow_top_right_tags", this.tagsToShow, this.parentInstance);
		// @ts-expect-error
		this.drawflowHelpers = new DrawflowHelpers(this.parentInstance);
	},
};
</script>
